import { getLocaleStaticPaths, withLocale } from "@lib/i18n/pagesRouter";
import QualificationPage from "@modules/booking/pages/QualificationPage";
import { GetStaticProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

const Meeting = () => {
  return <QualificationPage />;
};

export default Meeting;

const getLocalizedStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale!)),
    },
  };
};

export const getStaticProps = withLocale(getLocalizedStaticProps);
export const getStaticPaths = getLocaleStaticPaths;
